import React from 'react';
import styled from 'styled-components';

const PolicyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.textStrong};
`;

const Content = styled.div`
  font-size: 1rem;
  line-height: 1.7;

  h2 {
    font-size: 1.5rem;
    margin: 1.5rem 0 1rem;
    color: ${({ theme }) => theme.textStrong};
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
  
  a {
    color: var(--primary);
    text-decoration: none;
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 1px;
      bottom: -1px;
      left: 0;
      background-color: var(--primary);
      transition: width 0.3s ease;
    }
    
    &:hover {
      &:after {
        width: 100%;
      }
    }
  }
`;

const RefundPolicy = () => {
  return (
    <PolicyContainer>
      <Title>Refund Policy</Title>
      <Content>
        <p>
          Mystream Limited, registered in Cyprus under registration number HE423185, with its principal place
          of business at Spirou Kyprianou, 78, MAGNUM BUSINESS CENTER, 3rd floor, 3076, Limassol,
          Cyprus (herein referred to as "we", "our", or "us"), grants you access to our cross-platform
          application (hereafter referred to as "the Application"), available via our website.
        </p>

        <h2>Refund Eligibility</h2>
        <p>
          Refunds are granted only in cases where, after successful payment, you have not received access
          to the Application (hereafter referred to as "Access Discrepancies").
        </p>
        <p>
          If you encounter such issues, please contact our support team at <a href="mailto:support@1cal.ai">support@1cal.ai</a> within 14
          (fourteen) business days of the payment. We will aim to resolve the issue within this timeframe. If
          resolution is not achieved, a full refund will be issued.
        </p>

        <h2>How Refunds Are Processed</h2>
        <p>
          Refunds will be made using the same payment method used during the original transaction and will
          follow the refund rules of our third-party payment provider. We are not responsible for any delays or
          additional processing time imposed by these providers.
        </p>

        <h2>No Refunds in the Following Cases</h2>
        <p>We do not issue refunds in the following cases:</p>
        <ul>
          <li>You were granted access to the Application but chose not to use it.</li>
          <li>You did not use any paid features, start or complete any plans, or engage with the functionality provided.</li>
          <li>You failed to cancel an ongoing subscription before the next billing cycle (if applicable).</li>
          <li>Termination of your account due to a breach of the Terms of Service.</li>
        </ul>

        <h2>Refund Policy</h2>
        <p>
          Upon payment, you acknowledge and agree that digital access to the Application is provided
          immediately, and you waive your right to a refund under the EU "14-day cooling-off period" for digital
          services.
        </p>

        <h2>Subscription Terms</h2>
        <p>
          If your payment was part of a recurring subscription, you are responsible for managing and
          cancelling your subscription before the next billing cycle to avoid additional charges. No partial
          refunds are issued for unused portions of a subscription period.
        </p>

        <h2>Termination by Us</h2>
        <p>
          If we terminate your access without cause (i.e., you did not breach the Terms of Service), we will
          issue a pro-rated refund based on the number of days you were unable to use the Application after
          termination.
        </p>

        <h2>Governing Law</h2>
        <p>
          This Refund Policy shall be governed by the laws of the Republic of Cyprus. Any disputes shall be
          subject to the exclusive jurisdiction of the courts located in Limassol, Cyprus.
        </p>
      </Content>
    </PolicyContainer>
  );
};

export default RefundPolicy; 